export default __webpack_public_path__ + "static/lsa-boss-mobile-49f0332d2274a38f5a022c970faf4962.jpg";